import React, { useEffect, useState } from "react";

const DropArea = ({
  positionBottom,
  positionTop,
  positionRight,
  positionLeft,
  color,
  text,
  width,
  height,
  onMouseUp,
  topBottom,
  textColor,
  fontSize,
  area,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="divRow"
      onMouseUp={() => onMouseUp(area)}
      style={{
        opacity: hover ? "100%" : "50%",
        transform: topBottom ? "translate(50%, 0%)" : "translate(0%, 50%)",
        position: "absolute",
        bottom: positionBottom,
        left: positionLeft,
        right: positionRight,
        top: positionTop,
        backgroundColor: color,
        width,
        height,
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "1rem/1rem",
      }}
    >
      <div
        className="textBoldWhite"
        style={{ textAlign: "center", color: textColor, fontSize: fontSize }}
      >
        {text}
      </div>
    </div>
  );
};

export default DropArea;
